exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggest-enter-active[data-v-d7f407a8],.suggest-leave-active[data-v-d7f407a8]{-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),height .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),height .3s cubic-bezier(.23,1,.32,1)}.suggest-enter[data-v-d7f407a8]{height:0!important}.suggest-enter[data-v-d7f407a8],.suggest-leave-to[data-v-d7f407a8]{opacity:0}", ""]);

// exports
